import styled from 'styled-components'
import Icon from './Icon'

const GearIcon = styled(Icon).attrs({
  type: 'gear',
})``

export default GearIcon
